<template>
	<div class="translucent-overlay"></div>
</template>

<script>

export default {
	name: "TranslucentOverlay",
};
</script>

<style lang="scss" scoped>
.translucent-overlay {
	z-index: 100;
	position: absolute;
	top: 0;
	left: 0;
	bottom: 0;
	width: 100%;
	background-color: rgba(255, 255, 255, 0.492)
}
</style>
